import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language || 'de';

  const change = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex items-center gap-1 px-3 py-1.5 text-xs text-slate-400">
      <Globe className="w-3.5 h-3.5" />
      <button
        onClick={() => change('de')}
        data-testid="lang-de"
        className={`px-1.5 py-0.5 rounded ${current === 'de' ? 'bg-slate-700 text-white' : 'hover:text-slate-200'}`}
      >DE</button>
      <span className="text-slate-600">·</span>
      <button
        onClick={() => change('en')}
        data-testid="lang-en"
        className={`px-1.5 py-0.5 rounded ${current === 'en' ? 'bg-slate-700 text-white' : 'hover:text-slate-200'}`}
      >EN</button>
    </div>
  );
};

export default LanguageSwitcher;
